import { render, staticRenderFns } from "./My_Photo.vue?vue&type=template&id=3559dfee&scoped=true"
import script from "./My_Photo.vue?vue&type=script&lang=js"
export * from "./My_Photo.vue?vue&type=script&lang=js"
import style0 from "./My_Photo.vue?vue&type=style&index=0&id=3559dfee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3559dfee",
  null
  
)

export default component.exports